import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const ConfirmDelete = ({ open, title, description, onConfirm, onCancel }) => (
  <AlertDialog open={open} onOpenChange={(o) => !o && onCancel()}>
    <AlertDialogContent className="border-white/10 bg-ink-900">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-display text-2xl">{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="confirm-delete-cancel">Batal</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} className="bg-rose-600 text-white hover:bg-rose-500" data-testid="confirm-delete-confirm">
          Hapus
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
